import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/components/HomePage";
import BookTestPage from "@/components/BookTestPage";
import ServicesPage from "@/components/ServicesPage";
import GetQuotePage from "@/components/GetQuotePage";
import WhatIsRadonPage from "@/components/WhatIsRadonPage";

function removeEmergentBadge() {
  const badge = document.getElementById("emergent-badge");
  if (badge) badge.remove();
  document.querySelectorAll('a[href*="emergent-badge"]').forEach(el => el.remove());
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    removeEmergentBadge();
    const interval = setInterval(removeEmergentBadge, 200);
    const observer = new MutationObserver(removeEmergentBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => { clearInterval(interval); observer.disconnect(); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/book-test" element={<BookTestPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/get-quote" element={<GetQuotePage />} />
          <Route path="/what-is-radon" element={<WhatIsRadonPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
